import { useState, useEffect, type ReactNode } from "react";

interface TypewriterProps {
  text: string;
  speed?: number;
  chunkSize?: number;
  disableAnimation?: boolean;
  onChunk?: () => void;
  onComplete?: () => void;
  children?: (text: string) => ReactNode;
}

export const Typewriter = ({
  text,
  speed = 10,
  chunkSize = 3,
  disableAnimation,
  onChunk,
  onComplete,
  children,
}: TypewriterProps) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    if (!text) {
      setDisplayedText("");
      onComplete?.();
      return;
    }

    if (disableAnimation) {
      setDisplayedText(text);
      onComplete?.();
      return;
    }

    let i = 0;
    setDisplayedText("");
    const interval = setInterval(() => {
      const nextChunk = text.slice(i, i + chunkSize);
      setDisplayedText((prev) => prev + nextChunk);
      onChunk?.();
      i += chunkSize;
      if (i >= text.length) {
        clearInterval(interval);
        onComplete?.();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, chunkSize, disableAnimation]);

  if (children) return <>{children(displayedText)}</>;
  return <span>{displayedText}</span>;
};
